import { useContext } from "react";
import { TeamsFxContext } from "./Context";
import { KanbanBoard } from "./kanban/KanbanBoard";

export default function Tab() {
  const { themeString } = useContext(TeamsFxContext);
  return (
    <div
      className={themeString === "default" ? "light" : themeString === "dark" ? "dark" : "contrast"}
    >
      <KanbanBoard />
    </div>
  );
}
